import products from './products.js';
// import LocalData from './localData.js';
import events from './event.js';
// import selectProduct from './selectProduct.js';
import Storage from './storage.js';
import { textDiv, getNumber } from './texts.js';
import Logger from './logger.js';
import db from './db.js';
import CoverDialog from './coverDialog.js';

class GotoProduct {
    customizerContentDiv = null;
    wrapperDiv = null;
    userHasClickedOnForceNavigate = false;
    dataSaved = false;

    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;
        if (!this.customizerContentDiv) {
            Logger.error('GotoProduct constructor: customizerContentDiv is not defined');
            return;
        }

        this.init();
    }

    async init() {
        if (this.wrapperDiv) {
            // If already initialized, just show the wrapper, handled by CSS
            return;
        }

        // Create the wrapper div
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-gotoProduct-wrapper');
        textDiv(this.wrapperDiv, 'gotoProduct_general_text');
        this.customizerContentDiv.appendChild(this.wrapperDiv);

        events.add('stepChanged', (step) => {
            if (step === 'gotoProduct') {
                this.navigateToProductPage();
            }
        });
        events.add('forceNavigateToProductPage', async () => {
            this.userHasClickedOnForceNavigate = true;
            // await this.doNavigateToProductPage();
        });
    }


    async checkIfUploadIsComplete() {
        const activeImageID = Storage.get('activeImageID');
        if (!activeImageID) {
            Logger.error('Cannot wait for upload, no image found.');
            return false;
        }
        let imgData = await db.getImageData(activeImageID);

        // Om ingen data finns alls
        if (!imgData) {
            Logger.error('Image data not found.');
            return false;
        }

        // Om status redan är klar
        if (imgData.uploadStatus === 'uploaded') {
            return true;
        }

        // Om det blev fel
        if (imgData.uploadStatus === 'failed') {
            // Logger.error('Image upload failed. Cannot proceed.');
            CoverDialog.show({
                type: 'uploadFailed',
                data: { errorMessage: 'No image data uploaded.' }
            });
            console.error('Image upload failed for image ID:', activeImageID);
            return false;
        }

        // Här startar vi loopen om den fortfarande laddar upp eller konverterar
        // Vi visar en loading overlay så användaren vet varför inget händer
        if (imgData.uploadStatus === 'pending' || imgData.uploadStatus === 'converting') {
            events.trigger('showLoadingOverlay', 'gotoProduct');
            if (typeof hj === 'function') { hj('event', 'gotoProduct_waiting_upload'); }
        }

        let checks = 0;
        const maxChecks = 600; // 600 * 500ms = 5 minuter timeout (för säkerhets skull)

        while (imgData && (imgData.uploadStatus === 'pending' || imgData.uploadStatus === 'converting')) {
            if (checks > maxChecks) {
                Logger.error('Timeout waiting for upload.');
                return false;
            }

            await new Promise(resolve => setTimeout(resolve, 500)); // Vänta 500ms

            imgData = await db.getImageData(activeImageID);
            checks++;

            // Logga ibland för debugging
            if (checks % 10 === 0) {
                Logger.debug(`Still waiting for upload... Status: ${imgData?.uploadStatus}`);
                if (typeof hj === 'function') { hj('event', 'gotoProduct_still_waiting_upload'); }
            }
        }

        // En sista koll efter loopen
        if (imgData && imgData.uploadStatus === 'uploaded') {
            Logger.debug('Upload confirmed complete inside GotoProduct.');
            // Vänta en kort stund extra för att säkerställa att ev. thumbnails är sparade');
            await this.shortWait();
            return true;
        } else {
            // Logger.error('Upload finished but status is not uploaded:', imgData?.uploadStatus);
            Logger.error('Upload did not complete successfully.');
            return false;
        }
    }


    async shortWait() {
        return new Promise(resolve => setTimeout(resolve, 500));
    }

    async saveData() {
        events.trigger('uploadProgress', { percent: 15 });

        // 1. Vänta på att huvudbilden är helt uppladdad till servern
        const uploadSuccess = await this.checkIfUploadIsComplete();

        if (!uploadSuccess) {
            // Om uppladdningen misslyckades, avbryt navigeringen
            this.dataSaved = false;
            // Logger.error('Data save aborted due to upload failure.');
            CoverDialog.show({
                type: 'uploadFailed',
                data: { errorMessage: 'Image upload failed.' }
            });
            events.trigger('setStep', 'upload'); // Gå tillbaka till upload-steget
            return;
        }

        events.trigger('uploadProgress', { percent: 70 });

        // 2. Nu när bilden är på plats, generera och ladda upp thumbnail (om det behövs)
        await events.trigger('uploadAndSaveThumbnail');
        await this.shortWait();

        events.trigger('uploadProgress', { percent: 95 });

        // 3. Spara sessionen
        Storage.commitSession();

        events.trigger('uploadProgress', { percent: 100 });

        // 4. Markera som klart
        this.dataSaved = true;
    }

    async navigateToProductPage() {
        this.dataSaved = false;

        this.saveData(); // do save in background

        let dataDoneSaveCoverLoaded = false;
        const maxWaitTime = 30000; // 30 sec max wait
        const startTime = Date.now();

        // Step 1: Wait until data is saved
        while (!this.dataSaved && (Date.now() - startTime) < maxWaitTime) {
            if ((Date.now() - startTime) > 5000) {
                if (typeof hj === 'function') { hj('event', 'gotoProduct_data_save_waiting'); }
            }
            await new Promise(resolve => setTimeout(resolve, 300));
        }

        // Only proceed if data was saved
        if (!this.dataSaved) {
            Logger.error('Data save timed out, not navigating');
            return;
        }

        // Step 2: Data is saved, show proceed overlay
        if (!dataDoneSaveCoverLoaded) {
            dataDoneSaveCoverLoaded = true;
            // Hämta produktlänk
            const theProducts = await products.getProducts();
            const selectProduct = Storage.get('selectProduct');
            const product_permalink = theProducts.find(p => p.value == selectProduct)?.permalink;
            events.trigger('showLoadingOverlay', 'gotoProduct_proceed', product_permalink);

            const proceedOverlayTime = getNumber('gotoProduct_proceed_overlay_time', 0);
            const proceedStartTime = Date.now();
            const hasTimeout = proceedOverlayTime > 0;

            // Wait for either: timeout (if set) OR force click
            while (!this.userHasClickedOnForceNavigate) {
                if (hasTimeout && (Date.now() - proceedStartTime) >= proceedOverlayTime) {
                    break; // Timeout reached, exit loop
                }
                if (!hasTimeout && (Date.now() - proceedStartTime) > 5000) {
                    if (typeof hj === 'function') { hj('event', 'gotoProduct_waiting_for_user_click'); }
                }
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        }

        // Step 3: Navigate to product page
        await this.doNavigateToProductPage();
        // Nollställ force click först efter navigationen
        this.userHasClickedOnForceNavigate = false;
    }

    async doNavigateToProductPage() {
        const theProducts = await products.getProducts();
        const selectProduct = Storage.get('selectProduct');
        if (!selectProduct) {
            Logger.error('No product selected, cannot navigate to product page');
            return;
        }
        if (!theProducts || theProducts.length === 0) {
            Logger.error('No products found, cannot navigate to product page');
            return;
        }

        // find the product with product.value == this.data.product
        const product_permalink = theProducts.find(p => p.value == selectProduct)?.permalink;
        if (product_permalink) {
            window.location.href = product_permalink;
            //TODO: if already on the product page, update product on page with the new data
        } else {
            Logger.error('Product permalink not found for product:', selectProduct);
        }
    }

}
export default GotoProduct;